import { defineTheme } from "@astryxdesign/core/theme";
import { neutralTheme } from "@astryxdesign/theme-neutral";

/**
 * Neutral base + the karrtopelka soft-pink accent (same #ff6fa5 family as the
 * games) on a near-OLED body. Runtime injection is fine here: pure CSR SPA.
 */
export const hqTheme = defineTheme({
  name: "hq",
  extends: neutralTheme,
  tokens: {
    "--color-accent": ["#d94f82", "#ff6fa5"],
    "--color-accent-muted": ["#ff6fa533", "#ff6fa540"],
    "--color-text-accent": ["#bc3a6a", "#ff9ec6"],
    "--color-icon-accent": ["#d94f82", "#ff6fa5"],
    "--color-background-body": ["#f7f3f5", "#0b0b0c"],
    "--color-background-surface": ["#ffffff", "#161618"],
    "--color-background-popover": ["#ffffff", "#1f1f22"],
  },
});
